const OVERVIEW_CONTENT_CONSTANTS = {
  SLASH: '/',
  PERCENT: '%',
  DASH: '-',
  FUE: 'FUE',
  FUE_CONSUMPTION_TITLE: 'FUE CONSUMPTION',
  FUE_CONSUMPTION_TREND_TITLE: 'FUE CONSUMPTION TREND',
  FUE_DESCRIPTION: 'Allocated of contract allocation',
  LICENSE_INVENTORY_TITLE: 'LICENSE INVENTORY',
  FUE_LOAD_ERROR: 'Failed to load FUE consumption data',
  INVENTORY_LOAD_ERROR: 'Failed to load license inventory data',
  TREND_LOAD_ERROR: 'Failed to load consumption trend data',
  DISTRIBUTION_LOAD_ERROR: 'Failed to load identity distribution data',
  IDENTITY_TYPE_DISTRIBUTION: 'IDENTITY TYPE DISTRIBUTION',
  RETRY: 'Retry',
  VIEW_ALL: 'View All',
  VIEW_LESS: 'View Less',
  DISTRIBUTION_COLORS: ['#0294F7', '#53E596', '#F6A91C', '#E5362F'],
  NO_LICENSE_DATA_TITLE: 'No license data available',
  NO_LICENSE_DATA_DESCRIPTION:
    'Add your license information to view consumption metrics, inventory, and trends.',
} as const;

export default OVERVIEW_CONTENT_CONSTANTS;
